enum USER_ROLES {
  ADMIN = 'admin',
  CLIENT = 'client',
}

export default USER_ROLES;
